import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Follow-up prompts offered under a reply, as chips the reader can send with one click.
 *
 * Knows nothing about agents or alerts — it takes strings and emits the one that was picked — so
 * any DEO surface that wants to suggest what to ask next can use it.
 *
 * @example
 * ```html
 * <deo-conversation-chips [prompts]="reply.followUps" (chosen$)="ask($event)"></deo-conversation-chips>
 * ```
 */
@Component({
  selector: 'deo-conversation-chips',
  standalone: false,
  templateUrl: './deo-conversation-chips.component.html',
  styleUrl: './deo-conversation-chips.component.scss'
})
export class DeoConversationChipsComponent {
  @Input() prompts: string[] = [];

  /** Names the group for assistive technology, since the chips carry no visible heading. */
  @Input() label = 'Follow-up questions';

  @Input() disabled = false;

  @Output() chosen$ = new EventEmitter<string>();

  get hasPrompts(): boolean {
    return this.prompts.length > 0;
  }

  choose(prompt: string): void {
    if (this.disabled) {
      return;
    }

    this.chosen$.emit(prompt);
  }

  protected trackByPrompt(index: number, prompt: string): string {
    return prompt;
  }
}
